import React from "react"

import { parse } from "node-html-parser"

import CubewiseLink from "./_base/CubewiseLink"

import { ChildSelector } from "../helpers/ChildSelector"

import * as courseAtGlanceStyles from "../styles/CourseAtGlance.module.css"

export default function CourseAtGlance(props) {
  const { content } = props

  const items = ChildSelector.select(
    content,
    `edu-course-at-glance-item`,
    ChildSelector.SELECTOR_TYPE.ARRAY,
  )
    .map(card => ({
      label: ChildSelector.select(
        card,
        `edu-course-at-glance-label`,
        ChildSelector.SELECTOR_TYPE.TEXT,
      ),
      value: ChildSelector.select(
        card,
        `edu-course-at-glance-value`,
        ChildSelector.SELECTOR_TYPE.INNER_HTML,
      ),
      note: ChildSelector.select(
        card,
        `edu-course-at-glance-note`,
        ChildSelector.SELECTOR_TYPE.INNER_HTML,
      ),
    }))
    .map(it => {
      const vn = it.value && parse(it.value.replace(/[\r\n]/gm, ""))
      const nn = it.note && parse(it.note.replace(/[\r\n]/gm, ""))

      let v = null
      if (vn && vn.childNodes) {
        const anchors = vn.childNodes.filter(
          cn => cn.tagName && cn.tagName.toLowerCase() === `a`,
        )
        if (Array.isArray(anchors) && anchors.length) v = anchors
      }

      let n = null
      if (nn && nn.childNodes) {
        const anchors = nn.childNodes.filter(
          cn => cn.tagName && cn.tagName.toLowerCase() === `a`,
        )
        if (Array.isArray(anchors) && anchors.length) n = anchors
      }

      return {
        label: it.label,
        value: it.value,
        v: v,
        note: it.note,
        n: n,
      }
    })

  return (
    <div className={`row ${courseAtGlanceStyles.wrapper}`}>
      {items &&
        items.map((item, idx) => (
          <div
            key={idx}
            className={`col-12 col-lg-4 ${courseAtGlanceStyles.group}`}
          >
            <h3 className={`${courseAtGlanceStyles.label}`}>{item.label}</h3>
            {!item.v && (
              <p
                className={`${courseAtGlanceStyles.value}`}
                dangerouslySetInnerHTML={{ __html: item.value }}
              />
            )}
            {item.v &&
              item.v.map((iv, indx) => (
                <CubewiseLink
                  key={indx}
                  linkPath={(iv && iv.attrs.href) || null}
                  isFile={false}
                  openBlank={false}
                  translate={true}
                  pageContext={props.pageContext}
                  modals={props.modals}
                >
                  {iv && (
                    <span dangerouslySetInnerHTML={{ __html: iv.rawText }} />
                  )}
                </CubewiseLink>
              ))}
           {/*  <p
              className={`${courseAtGlanceStyles.note}`}
              dangerouslySetInnerHTML={{ __html: item.note }}
            /> */}
          </div>
        ))}
    </div>
  )
}
